import React from 'react'
import type { BetSlipWorkflowState } from '@mobi/betslip/Store/Workflow'
import { BetSlipContext } from '@mobi/betslip/context'
import { BetsPlacedSuccessToast } from '../Components/BetsPlacedSuccessToast'

export const useBetsPlacedSuccessToast = (
  workflowStatus: BetSlipWorkflowState['currentStatus']
) => {
  const toastEmitter = React.useContext(BetSlipContext)?.toastEmitter

  React.useEffect(() => {
    if (workflowStatus !== 'bets-placed' || !toastEmitter) return

    const id = 'betslip-bets-placed-success'

    toastEmitter.emit('addToast', {
      id,
      component: <BetsPlacedSuccessToast id={id} />,
    })

    return () => toastEmitter.emit('removeToast', { id })
  }, [workflowStatus, toastEmitter])
}
